import { render, staticRenderFns, recyclableRender, components } from "./coupon.vue?vue&type=template&id=32ef155e&scoped=true&"
var renderjs
import script from "./coupon.vue?vue&type=script&lang=js&"
export * from "./coupon.vue?vue&type=script&lang=js&"
import style0 from "./coupon.vue?vue&type=style&index=0&id=32ef155e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef155e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/product/detail/popup/coupon.vue"
export default component.exports